import { useEffect, useRef } from 'react'
import { useHistory } from 'react-router'

import { useCompanyId } from 'providers/CompanyProvider'

const useRedirectOnCompanyChange = (redirectPath: string): void => {
  const history = useHistory()
  const companyId = useCompanyId() || 0
  const previousCompanyId = useRef(companyId)

  useEffect(() => {
    if (previousCompanyId.current && previousCompanyId.current !== companyId) {
      history.replace(redirectPath)
    }
    previousCompanyId.current = companyId
  }, [companyId, history, redirectPath])
}

export { useRedirectOnCompanyChange }
